<div class="modal-main">
  <div class="modal-header">
    <h2 class="modal-title" transloco="symptomSurvey">Symptom Survey</h2>
    <i class="icon-close ml-auto my-auto" (click)="modal.dismiss()"></i>
  </div>
  <h3 [innerHTML]="'symptomSurveyCopy' | transloco">Did you know that infectious diseases like COVID-19, mycoplasma and influenza all have similar symptoms? By filling this out you can help us inform you about risks and trends in your area.</h3>
  <form class="modal-body" #form="ngForm" (ngSubmit)="onSubmit(form)">
    <div class="row my-4">
      <div class="col-9 col-md-5">
        <label transloco="symptomsStart">When did your symptoms start?</label>
        <input type="text" name="start_date" id="start_date" ngModel [placeholder]="'symptomsStartBlank' | transloco" #startDate="bsDatepicker"
               bsDatepicker [bsConfig]="{showWeekNumbers: false, containerClass: 'theme-default'}" placement="bottom"
               [minDate]="minDate" [maxDate]="today">
      </div>
      <div class="col-9 col-md-5">
        <label transloco="symptomsEnd">When did your symptoms end?</label>
        <input type="text" name="end_date" id="end_date" ngModel [placeholder]="'symptomsEndBlank' | transloco"
               bsDatepicker [bsConfig]="{showWeekNumbers: false, containerClass: 'theme-default'}" placement="bottom"
               [minDate]="startDate?._bsValue || null" [maxDate]="today">
      </div>
      <div class="col-9 col-md-2">
        <label transloco="zipCode">ZIP Code</label>
        <input type="text" name="zip" id="zip" [(ngModel)]="zip" mask="00000-9999" required>
      </div>
    </div>
    <div class="row my-4 symptoms">
      <label class="col-12" transloco="symptomsList">What are your symptoms? (check all that apply)</label>
      <div class="d-inline-block ml-4 mt-3" *ngFor="let symptom of symptoms; index as i">
        <input type="checkbox" class="neo-select" [name]="symptom" [id]="symptom" ngModel>
        <label [for]="symptom">{{ 'symptom.' + symptom | transloco }}</label>
      </div>
    </div>
    <div class="row mt-4 mb-5">
      <button class="ab_button mx-auto">Submit</button>
    </div>
  </form>
  <div class="mx-4 mb-4 font-weight-light">
    <b>DISCLAIMER: </b><span transloco="symptomsDisclaimer">This survey is for research purposes only and not intended to prevent or diagnose any disease. Always seek the advice of your physician or other qualified health care provider regarding any symptoms or treatment.</span>
  </div>
</div>
